<div class="chat-header">
  <p class="mb-0">
    <i class="bi bi-chat-dots me-2" aria-hidden="true"></i>Conversazione con la persona. I nuovi messaggi non
    arrivano in tempo reale: la chat si aggiorna da sola ogni 10 secondi, oppure usa
    <span class="fw-bold">Aggiorna</span>.
  </p>
  <button type="button" class="btn btn-outline-secondary btn-sm" [disabled]="refreshing" (click)="refresh()">
    <i class="bi bi-arrow-clockwise me-1" aria-hidden="true"></i>{{ refreshing ? 'Aggiornamento...' : 'Aggiorna' }}
  </button>
</div>

<div class="alert alert-warning py-2 mt-2" role="alert" *ngIf="refreshFailed">
  Non è stato possibile aggiornare la chat. <button type="button" class="btn btn-link p-0 align-baseline" (click)="refresh()">Riprova</button>
</div>

<div #chatList class="chat-list" aria-live="polite">
  <p class="empty-state" *ngIf="messages.length === 0">Nessun messaggio in questa chat.</p>

  <div class="chat-row" *ngFor="let m of messages; trackBy: trackById" [class.from-user]="isFromUser(m)">
    <div class="chat-bubble" [class.user-bubble]="isFromUser(m)">
      <div class="chat-meta">
        <span class="fw-bold">{{ authorLabel(m) }}</span>
        <span>{{ m.sentOn | date: 'dd/MM/yyyy HH:mm' }}</span>
      </div>

      <ng-container *ngIf="editingId !== m.id; else editing">
        <p class="chat-text">{{ m.message }}</p>

        <div class="chat-actions" *ngIf="deletingId !== m.id; else confirmDeleting">
          <button type="button" class="btn btn-link btn-sm p-0" (click)="startEdit(m)">
            <i class="bi bi-pencil me-1" aria-hidden="true"></i>Modifica
          </button>
          <button type="button" class="btn btn-link btn-sm p-0 text-danger" (click)="askDelete(m)">
            <i class="bi bi-trash me-1" aria-hidden="true"></i>Elimina
          </button>
        </div>
        <ng-template #confirmDeleting>
          <div class="chat-actions" role="alertdialog" aria-label="Conferma eliminazione">
            <span>Eliminare questo messaggio?</span>
            <button type="button" class="btn btn-danger btn-sm" [disabled]="deleteBusy" (click)="confirmDelete(m)">
              {{ deleteBusy ? 'Eliminazione...' : 'Elimina' }}
            </button>
            <button type="button" class="btn btn-outline-secondary btn-sm" [disabled]="deleteBusy" (click)="cancelDelete()">
              Annulla
            </button>
          </div>
        </ng-template>
      </ng-container>

      <ng-template #editing>
        <textarea class="form-control" rows="3" [formControl]="editControl" aria-label="Modifica messaggio"></textarea>
        <div class="chat-actions">
          <button
            type="button"
            class="btn btn-secondary text-white btn-sm"
            [disabled]="editSaving || !editControl.value.trim()"
            (click)="saveEdit(m)"
          >
            {{ editSaving ? 'Salvataggio...' : 'Salva' }}
          </button>
          <button type="button" class="btn btn-outline-secondary btn-sm" [disabled]="editSaving" (click)="cancelEdit()">
            Annulla
          </button>
        </div>
      </ng-template>
    </div>
  </div>
</div>

<div class="chat-compose">
  <textarea
    class="form-control"
    rows="3"
    placeholder="Scrivi una risposta..."
    aria-label="Scrivi una risposta"
    [formControl]="draft"
  ></textarea>
  <button
    type="button"
    class="btn btn-secondary text-white"
    [disabled]="sending || !draft.value.trim()"
    (click)="send()"
  >
    {{ sending ? 'Invio...' : 'Invia' }}
  </button>
</div>
